import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-pin",
  "use": "svg_i-pin-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 14\" id=\"svg_i-pin\"><path d=\"M14.25 6.143 8.356.25 7.18 1.429l1.105 1.105L3.79 6.29l-.147-.147a1.666 1.666 0 0 0-2.357 0l-.59.59 2.947 2.945-2.946 2.946v1.18h1.179l2.946-2.947 2.946 2.946.59-.59a1.667 1.667 0 0 0 0-2.356l-.148-.147 3.756-4.494 1.105 1.105 1.178-1.178z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol